import React, { useEffect, useState } from "react";
import apiClient from "../utils/apiClient";
import "./EmployeeAssetProfile.css";

const EmployeeAssetProfile = () => {
  const [employees, setEmployees] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    fetchAssets();
  }, []);

  const fetchAssets = async () => {
    try {
      const data = await apiClient(
        "/assets/list/"
      );

      const assets = Array.isArray(data)
        ? data
        : data?.results || [];

      const grouped = {};

      assets.forEach((item) => {
        if (!item.employee_id) return;

        if (!grouped[item.employee_id]) {
          grouped[item.employee_id] = {
            employee_id: item.employee_id,
            employee_name: item.employee_name,
            email: item.email,
            department: item.department,
            designation: item.designation,
            assets: [],
          };
        }

        grouped[item.employee_id].assets.push(item);
      });

      const employeeList = Object.values(grouped);

      setEmployees(employeeList);

      if (employeeList.length > 0) {
        setSelectedEmployee(employeeList[0]);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const filteredEmployees = employees.filter(
    (emp) =>
      emp.employee_name
        ?.toLowerCase()
        .includes(searchTerm.toLowerCase()) ||
      emp.employee_id
        ?.toLowerCase()
        .includes(searchTerm.toLowerCase())
  );

  const currentLaptop =
    selectedEmployee?.assets.find(
      (x) => x.status === "Active"
    );

  return (
    <div className="empAsset-page">

      <div className="empAsset-header">
        <h2>Employee Profile</h2>
        <p>
          Current laptop and assignment history
        </p>
      </div>

      <div className="empAsset-layout">

        {/* LEFT SIDEBAR */}

        <div className="empAsset-sidebar">

          <input
            type="text"
            placeholder="Search employee..."
            className="empAsset-search"
            value={searchTerm}
            onChange={(e) =>
              setSearchTerm(e.target.value)
            }
          />

          <div className="empAsset-list">

            {filteredEmployees.map((emp) => (
              <div
                key={emp.employee_id}
                className={`empAsset-user ${
                  selectedEmployee?.employee_id ===
                  emp.employee_id
                    ? "active"
                    : ""
                }`}
                onClick={() =>
                  setSelectedEmployee(emp)
                }
              >
                <h4>{emp.employee_name}</h4>

                <span>
                  {emp.employee_id}
                </span>

                <small>
                  {emp.department}
                </small>
              </div>
            ))}
          </div>
        </div>

        {/* RIGHT CONTENT */}

        {selectedEmployee && (
          <div className="empAsset-content">

            {/* PROFILE */}

            <div className="empAsset-card">

              <div className="empAsset-profileHeader">

                <div className="empAsset-avatar">
                  {selectedEmployee.employee_name
                    ?.substring(0, 2)
                    .toUpperCase()}
                </div>

                <div>
                  <h3>
                    {
                      selectedEmployee.employee_name
                    }
                  </h3>

                  <span>
                    {
                      selectedEmployee.employee_id
                    }
                  </span>
                </div>

              </div>

              <div className="empAsset-grid">

                <div className="empAsset-infoBox">
                  <label>Email</label>
                  <p>
                    {selectedEmployee.email}
                  </p>
                </div>

                <div className="empAsset-infoBox">
                  <label>Department</label>
                  <p>
                    {
                      selectedEmployee.department
                    }
                  </p>
                </div>

                <div className="empAsset-infoBox">
                  <label>Designation</label>
                  <p>
                    {
                      selectedEmployee.designation
                    }
                  </p>
                </div>

              </div>

            </div>

            {/* CURRENT LAPTOP */}

            {currentLaptop && (
              <div className="empAsset-card">

                <h3>
                  Current Assigned Laptop
                </h3>

                <div className="empAsset-grid">

                  <div className="empAsset-infoBox">
                    <label>Asset No</label>
                    <p>
                      {
                        currentLaptop.asset_number
                      }
                    </p>
                  </div>

                  <div className="empAsset-infoBox">
                    <label>Brand</label>
                    <p>
                      {currentLaptop.brand}
                    </p>
                  </div>

                  <div className="empAsset-infoBox">
                    <label>Model</label>
                    <p>
                      {currentLaptop.model}
                    </p>
                  </div>

                  <div className="empAsset-infoBox">
                    <label>
                      Assigned Date
                    </label>
                    <p>
                      {
                        currentLaptop.assigned_date
                      }
                    </p>
                  </div>

                </div>

              </div>
            )}

            {/* HISTORY */}

            <div className="empAsset-card">

              <h3>
                Assignment History
              </h3>

              <div className="empAsset-timeline">

                {[...selectedEmployee.assets]
                  .sort(
                    (a, b) =>
                      new Date(
                        b.assigned_date
                      ) -
                      new Date(
                        a.assigned_date
                      )
                  )
                  .map((asset) => (
                    <div
                      key={asset.id}
                      className="empAsset-timelineItem"
                    >
                      <div className="empAsset-dot"></div>

                      <div className="empAsset-timelineContent">

                        <h4>
                          {asset.brand}{" "}
                          {asset.model}
                        </h4>

                        <span>
                          {
                            asset.asset_number
                          }
                        </span>

                        <p>
                          Assigned :
                          {" "}
                          {
                            asset.assigned_date
                          }
                        </p>

                        <p>
                          Returned :
                          {" "}
                          {asset.return_date ||
                            "Present"}
                        </p>

                        <p>
                          {asset.remarks ||
                            "-"}
                        </p>

                      </div>

                      <div>

                        <span
                          className={`empAsset-status ${asset.status?.toLowerCase()}`}
                        >
                          {asset.status}
                        </span>

                      </div>
                    </div>
                  ))}
              </div>

            </div>

          </div>
        )}
      </div>
    </div>
  );
};

export default EmployeeAssetProfile;